











import { defineComponent, ref } from "@vue/composition-api";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import VaultController from "@/components/VaultController";

export default defineComponent({
  name: "PageVault",
  components: { BasePage, PageTitle, VaultController, BaseIcon },
  setup(props, { root }) {
    const loading = ref(false);
    const access = checkAuthorities(root.$store.state?.authorities || [], ["updateMyContentPrice"]);
    if (!access) root.$router.replace({ name: "more" });
    return { loading };
  },
});
